import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DatabaseStats } from '../../types';

const initialState: DatabaseStats = {
  total_stocks: 0,
  stocks_with_data: 0,
  stocks_with_targets: 0,
  latest_passing: 0,
};

const databaseSlice = createSlice({
  name: 'database',
  initialState,
  reducers: {
    setDatabaseStats: (state, action: PayloadAction<DatabaseStats>) => {
      return { ...state, ...action.payload };
    },
    updateDatabaseStats: (state, action: PayloadAction<Partial<DatabaseStats>>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setDatabaseStats, updateDatabaseStats } = databaseSlice.actions;
export default databaseSlice.reducer; 